<template>
  <Modal v-model="open" :title="title" :width="480">
    <Tree
      :key="treeKey"
      ref="Tree"
      :data="permitsData"
      show-checkbox
      check-directly
      multiple
      @on-check-change="checkChange"
    ></Tree>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('Tree')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { permitsList } from '@/api/permit'
import { rolesSetPermits } from '@/api/role'

function normalizeAuthIds(raw) {
  if (raw == null || raw === '') return []
  if (Array.isArray(raw)) return raw.map((x) => String(x).trim()).filter(Boolean)
  return String(raw)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
}

function markTreeChecked(nodes, authIdSet) {
  if (!Array.isArray(nodes)) return []
  return nodes.map((item) => {
    const id = item.id != null ? String(item.id) : ''
    const children = Array.isArray(item.children) ? markTreeChecked(item.children, authIdSet) : []
    const selfChecked = id && authIdSet.has(id)
    const childCheckedCount = children.filter((c) => c.checked).length
    // 自身在权限列表中，或全部子节点已勾选 → 勾选；部分子节点勾选时父级由 Tree 显示半选
    const checked =
      selfChecked || (children.length > 0 && childCheckedCount === children.length)
    return {
      ...item,
      title: item.name || item.title || '',
      expand: true,
      checked: !!checked,
      children,
    }
  })
}

/** 收集勾选节点 id，并补上父级 id（菜单展示需要一级权限） */
function collectAuthIds(nodes, checkedList) {
  const idSet = new Set(checkedList.map((n) => String(n.id)))
  const walk = (list, parentIds) => {
    if (!Array.isArray(list)) return
    list.forEach((node) => {
      const id = node.id != null ? String(node.id) : ''
      const nextParents = id ? parentIds.concat(id) : parentIds
      const kids = node.children || []
      if (id && idSet.has(id)) {
        parentIds.forEach((pid) => idSet.add(pid))
      }
      if (kids.length) walk(kids, nextParents)
    })
  }
  walk(nodes, [])
  return Array.from(idSet)
}

export default {
  name: 'RolesPermits',
  data() {
    return {
      role_id: '',
      open: false,
      title: '分配权限',
      loading: false,
      auth_ids: '',
      treeKey: 0,
      permitsData: [],
    }
  },
  methods: {
    init(params) {
      this.role_id = params.roleId != null ? params.roleId : params.role_id
      const raw =
        params.auth_ids != null && params.auth_ids !== ''
          ? params.auth_ids
          : params.authIds
      this.auth_ids = raw != null ? String(raw) : ''
      this.title = '分配权限'
      this.open = true
      this.getList()
    },
    getList() {
      permitsList()
        .then((res) => {
          if (res.data.code === 200) {
            const authIdSet = new Set(normalizeAuthIds(this.auth_ids))
            const rawTree = Array.isArray(res.data.data) ? res.data.data : []
            // 先打勾再赋值，并用 key 强制重建 Tree，避免回显不生效
            this.permitsData = markTreeChecked(
              JSON.parse(JSON.stringify(rawTree)),
              authIdSet
            )
            this.treeKey = Date.now()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error(err && err.message ? err.message : err)
        })
    },
    ok(name) {
      const tree = this.$refs[name]
      if (!tree) return
      const checkedNodes = tree.getCheckedNodes() || []
      // 半选父节点也写入，保证一级菜单能显示
      let halfNodes = []
      if (typeof tree.getCheckedAndIndeterminateNodes === 'function') {
        halfNodes = tree.getCheckedAndIndeterminateNodes() || []
      }
      const merged = [...checkedNodes, ...halfNodes]
      const checks = collectAuthIds(this.permitsData, merged)
      const postData = {
        auth_ids: checks.join(','),
        role_id: this.role_id,
      }
      this.loading = true
      rolesSetPermits(postData)
        .then((res) => {
          this.loading = false
          if (res.data.code === 200) {
            this.$Message.success('分配权限成功')
            this.auth_ids = postData.auth_ids
            this.cancel()
            this.$emit('reload')
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error(err && err.message ? err.message : err)
        })
    },
    cancel() {
      this.open = false
    },
    checkChange() {
      // 关闭 check-strictly 后，勾选父级会级联勾选子级
    },
  },
}
</script>
